import React from 'react'

export default function MandatoryMark() {
  return (
    <span style={{color:'red', marginLeft: '0.3rem'}}>
      *
    </span>
  )
}
